import React from "react";
import moment from "moment-timezone";
import DateFormItem from "./DateFormItem";

export default ({ fieldProps, ...props }) => (
  <DateFormItem defaultDate={moment().add(-50, "Y")} {...fieldProps} {...props} />
);
